module.exports = __webpack_public_path__ + "img/ico2.f6bdbd1c.png";